import dateFNSFormat from 'date-fns/format';
import isValid from 'date-fns/isValid';

export const DATE_WITH_HOUR = 'yyyy-MM-dd HH:mm:ss'; // 2021-09-08 06:56:11
export const MONTH_DAY_HOUR = 'MMM dd, HH:mm'; //Sep 08, 06:56
export const DATE_FOR_API = 'yyyy-MM-dd'; // 2021-09-08
export const DAY_MONTH_YEAR = 'dd MMMM, yyyy'; // 08 September, 2021
export const DAY_MONTH = 'do MMM'; // 8th Sept

export const format = (date, dateFormat = DATE_FOR_API) => {
  if (!isValid(new Date(date))) return '-';

  return dateFNSFormat(new Date(date), dateFormat);
};
